module.exports = __webpack_public_path__ + "static/mentor-nalin-562a08734c4edd27e5e56c25ddd48ed4.png";